export const MARKETING_LEGAL_REDIRECT_TRANSLATIONS = {
  redirecting: {
    "pt-BR": "Redirecionando…",
    en: "Redirecting…",
    es: "Redirigiendo…",
    de: "Weiterleitung…",
  },
} as const;

export const APP_ROUTES_TRANSLATIONS = {
  loading: {
    "pt-BR": "Carregando…",
    en: "Loading…",
    es: "Cargando…",
    de: "Laden…",
  },
} as const;
